
export default {
    props: {
        items: {
            type: Array,
            default: () => { return []; }
        }
    }
};
